/* eslint-disable react/forbid-dom-props */
import React from 'react'

export const NavLogoIcon = () => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" width="175" height="33">
    <defs>
      <filter
        id="nav_logo_b"
        width="102.5%"
        height="104.9%"
        x="-1.3%"
        y="-2.4%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="-1" in="SourceAlpha" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          values="0 0 0 0 0.89342731 0 0 0 0 0.89342731 0 0 0 0 0.89342731 0 0 0 1 0"
        />
      </filter>
      <filter
        id="nav_logo_c"
        width="239.1%"
        height="239.1%"
        x="-69.6%"
        y="-69.6%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation="2.5"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter
        id="nav_logo_f"
        width="104.5%"
        height="103.7%"
        x="-2.2%"
        y="-2.4%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner1"
          stdDeviation=".5"
        />
        <feOffset in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          values="0 0 0 0 0.85436481 0 0 0 0 0.552928515 0 0 0 0 0.117117005 0 0 0 0.790947334 0"
        />
      </filter>
      <filter
        id="nav_logo_i"
        width="104.5%"
        height="106.3%"
        x="-2.2%"
        y="-3.1%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner1"
          stdDeviation=".5"
        />
        <feOffset in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          values="0 0 0 0 0.780392157 0 0 0 0 0.501960784 0 0 0 0 0.278431373 0 0 0 0.317498907 0"
        />
      </filter>
      <filter
        id="nav_logo_l"
        width="104.7%"
        height="107.1%"
        x="-2.3%"
        y="-3.3%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner1"
          stdDeviation=".5"
        />
        <feOffset in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          result="shadowMatrixInner1"
          values="0 0 0 0 1 0 0 0 0 0.71017264 0 0 0 0 0 0 0 0 0.535183566 0"
        />
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner2"
          stdDeviation=".5"
        />
        <feOffset in="shadowBlurInner2" result="shadowOffsetInner2" />
        <feComposite
          in="shadowOffsetInner2"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner2"
        />
        <feColorMatrix
          in="shadowInnerInner2"
          result="shadowMatrixInner2"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.475497159 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixInner1" />
          <feMergeNode in="shadowMatrixInner2" />
        </feMerge>
      </filter>
      <filter
        id="nav_logo_o"
        width="103.7%"
        height="110.4%"
        x="-1.4%"
        y="-5.2%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner1"
          stdDeviation=".5"
        />
        <feOffset in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          values="0 0 0 0 1 0 0 0 0 0.876656309 0 0 0 0 0.562690549 0 0 0 0.748333698 0"
        />
      </filter>
      <filter
        id="nav_logo_p"
        width="100%"
        height="100%"
        x="0%"
        y="0%"
        filterUnits="objectBoundingBox"
      >
        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
        <feColorMatrix
          in="shadowOffsetOuter1"
          values="0 0 0 0 0.708248415 0 0 0 0 0.406680315 0 0 0 0 0.00163296605 0 0 0 0.444192526 0"
        />
      </filter>
      <filter
        id="nav_logo_s"
        width="133%"
        height="132.8%"
        x="-16.5%"
        y="-16.4%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner1"
          stdDeviation=".5"
        />
        <feOffset dy="-1" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          result="shadowMatrixInner1"
          values="0 0 0 0 0.956862745 0 0 0 0 0.752941176 0 0 0 0 0.368627451 0 0 0 0.924797858 0"
        />
        <feGaussianBlur
          in="SourceAlpha"
          result="shadowBlurInner2"
          stdDeviation=".5"
        />
        <feOffset dy="-2" in="shadowBlurInner2" result="shadowOffsetInner2" />
        <feComposite
          in="shadowOffsetInner2"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner2"
        />
        <feColorMatrix
          in="shadowInnerInner2"
          result="shadowMatrixInner2"
          values="0 0 0 0 0.956862745 0 0 0 0 0.752941176 0 0 0 0 0.368627451 0 0 0 0.2 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixInner1" />
          <feMergeNode in="shadowMatrixInner2" />
        </feMerge>
      </filter>
      <linearGradient
        id="nav_logo_g"
        x1="3.393%"
        x2="100%"
        y1="37.914%"
        y2="66.448%"
      >
        <stop offset="0%" stopColor="#FFE3C1" />
        <stop offset="100%" stopColor="#EAC380" />
      </linearGradient>
      <linearGradient
        id="nav_logo_j"
        x1="13.026%"
        x2="91.397%"
        y1="27.58%"
        y2="64.145%"
      >
        <stop offset="0%" stopColor="#DB6C2F" />
        <stop offset="100%" stopColor="#FFB65C" />
      </linearGradient>
      <linearGradient
        id="nav_logo_m"
        x1="97.929%"
        x2="8.71%"
        y1="60.372%"
        y2="48.826%"
      >
        <stop offset="0%" stopColor="#FFB570" />
        <stop offset="100%" stopColor="#FFA94D" />
      </linearGradient>
      <linearGradient
        id="nav_logo_r"
        x1="71.895%"
        x2="56.218%"
        y1="11.829%"
        y2="56.723%"
      >
        <stop offset="0%" stopColor="#FFF" />
        <stop offset="100%" stopColor="#F9F9EF" />
      </linearGradient>
      <linearGradient
        id="nav_logo_t"
        x1="55.204%"
        x2="92.377%"
        y1="54.484%"
        y2="12.627%"
      >
        <stop offset="0%" stopColor="#FCF6E6" />
        <stop offset="100%" stopColor="#F0CA81" />
      </linearGradient>
      <path
        id="nav_logo_e"
        d="M.624 17.152l20.684 5.535a.786.786 0 00.989-.759V20.22l-20.67-4.686-.327-6.85 14.31-3.62c-.128-2.09-.865-3.001-2.211-2.734-.418.083-1.243.85-2.288 1.08-.762.169-1.641-.23-2.566 0-.688.172-1.4 1.038-2.11 1.237-.76.213-1.515-.239-2.228 0-.796.266-1.54 1.102-2.178 1.39C.729 6.624.04 6.549.04 7.162v9.231c0 .356.24.667.583.76z"
      />
      <path
        id="nav_logo_h"
        d="M22.293 7.137v9.231a.787.787 0 01-.583.76L1.026 22.661a.786.786 0 01-.988-.759v-1.707l20.67-4.686.326-6.85-.188-.048 1.26-1.88a.469.469 0 01.187.405z"
      />
      <path
        id="nav_logo_k"
        d="M.07 8.746l.193 6.706c.01.35.25.65.588.738l20.222 5.25v-6.764L.351 8.53a.22.22 0 00-.281.216z"
      />
      <path
        id="nav_logo_n"
        d="M14.608 5.065c-2.341-.139-4.424.01-6.25.445-1.778.424-4.452 1.428-8.02 3.01a.109.109 0 00.014.204l20.923 5.952-6.666-9.61z"
      />
      <path
        id="nav_logo_q"
        d="M5.113 0c2.544 1.62 3.885 3.384 4.024 5.292.03.191.04.386.03.584-.11 1.927-2.229 3.39-4.735 3.268-2.48-.12-4.41-1.749-4.343-3.651l-.001-.07-.002.006c.009-.068.014-.137.026-.203a2.81 2.81 0 01.28-.896c.493-1.037 1.515-1.736 3.064-2.094l.047-.011c2.073-.468 2.61-1.21 1.61-2.225z"
      />
      <radialGradient
        id="nav_logo_d"
        cx="51.378%"
        cy="50%"
        r="79.107%"
        fx="51.378%"
        fy="50%"
        gradientTransform="scale(.92857 1) rotate(-24.989 .534 .41)"
      >
        <stop offset="0%" stopColor="#F2D4A0" />
        <stop offset=".889%" stopColor="#FFCE92" />
        <stop offset="100%" stopColor="#F4D3A0" />
      </radialGradient>
      <ellipse
        id="nav_logo_a"
        cx="19.821"
        cy="10.263"
        rx="19.821"
        ry="10.263"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#B67144"
        fillRule="nonzero"
        d="M53.126 22.023v-4.5h2.176c1.164 0 2.24-.197 3.23-.591.99-.394 1.787-.996 2.392-1.807.604-.81.907-1.807.907-2.989 0-1.197-.284-2.216-.85-3.056a5.193 5.193 0 00-2.29-1.887c-.96-.416-2.029-.625-3.208-.625H49v15.455h4.126zm2.267-7.75h-2.267V9.818h2.221c.68 0 1.22.212 1.621.637.4.424.6.984.6 1.681 0 .606-.203 1.114-.611 1.523-.408.41-.93.614-1.564.614zm11.294 8.136c1.39 0 2.886-.5 4.488-1.5l1.18 1.136h1.994V11.023h-4.126v7.409a8.953 8.953 0 01-1.201.443c-.438.129-.778.193-1.02.193-.423 0-.726-.125-.907-.375-.181-.25-.272-.564-.272-.943v-6.727h-4.126v7.113c0 1.288.333 2.322.998 3.103.665.78 1.662 1.17 2.992 1.17zm13.425-.386v-7.41c.348-.15.737-.295 1.168-.431.43-.137.744-.205.94-.205.454 0 .745.114.873.341.129.227.193.553.193.977v6.728h4.126v-7.41c.347-.15.733-.295 1.156-.431.423-.137.733-.205.93-.205.453 0 .743.114.872.341.128.227.193.553.193.977v6.728h4.125v-7.114c0-2.848-1.292-4.273-3.876-4.273-1.27 0-2.652.455-4.149 1.364-.634-.91-1.677-1.364-3.128-1.364-1.315 0-2.773.5-4.375 1.5L78.435 11h-2.449v11.023h4.126zM96.371 27l4.126-.227v-4.728c.453.152.937.228 1.45.228 1.784 0 3.2-.504 4.251-1.512 1.05-1.007 1.575-2.473 1.575-4.397 0-1.894-.517-3.326-1.552-4.296-1.036-.97-2.4-1.454-4.092-1.454a4.63 4.63 0 00-1.598.284c-.522.19-1.01.443-1.462.761l-.635-.636H96.37V27zm5.304-7.91c-.347 0-.74-.098-1.178-.295v-4.659c.347-.227.68-.34.997-.34.65 0 1.149.223 1.496.67.348.447.522 1.087.522 1.92 0 .834-.174 1.493-.522 1.978-.347.484-.786.727-1.315.727zm11.408 2.933v-3.546l.748-.568 2.176 4.114h4.444l-3.718-6.296 2.924-2.204-2.47-2.841-4.104 3.477V5.977l-4.126.25v15.796h4.126zM122.995 9.5c.62 0 1.152-.22 1.598-.66a2.12 2.12 0 00.668-1.567 2.19 2.19 0 00-.668-1.603 2.179 2.179 0 00-1.598-.67c-.605 0-1.126.223-1.565.67a2.211 2.211 0 00-.657 1.603c0 .606.22 1.129.657 1.568.439.44.96.659 1.565.659zm2.085 12.523V11h-4.126v11.023h4.126zm5.763 0v-7.41a8.969 8.969 0 011.202-.443c.438-.128.778-.193 1.02-.193.423 0 .725.125.906.375.182.25.272.565.272.943v6.728h4.126v-7.114c0-1.288-.332-2.322-.997-3.102-.665-.78-1.663-1.17-2.993-1.17-1.39 0-2.886.5-4.488 1.5L129.166 11h-2.449v11.023h4.126zm18.236 0v-4.5h2.176c1.164 0 2.24-.197 3.23-.591.99-.394 1.788-.996 2.392-1.807.605-.81.907-1.807.907-2.989 0-1.197-.283-2.216-.85-3.056a5.193 5.193 0 00-2.29-1.887c-.96-.416-2.028-.625-3.207-.625h-6.484v15.455h4.126zm2.267-7.75h-2.267V9.818h2.222c.68 0 1.22.212 1.62.637.401.424.601.984.601 1.681 0 .606-.204 1.114-.612 1.523-.408.41-.93.614-1.564.614zm9.435-4.773c.62 0 1.153-.22 1.599-.66.445-.438.668-.961.668-1.567 0-.621-.223-1.156-.668-1.603a2.18 2.18 0 00-1.599-.67c-.604 0-1.125.223-1.564.67a2.211 2.211 0 00-.657 1.603c0 .606.219 1.129.657 1.568.439.44.96.659 1.564.659zm2.086 12.523V11h-4.126v11.023h4.126zm7.531.25c.892 0 1.765-.114 2.618-.341.854-.227 1.508-.508 1.961-.841l-1.156-2.796c-.967.5-1.972.75-3.015.75-.68 0-1.228-.132-1.643-.397a1.988 1.988 0 01-.85-1.103H175v-1.204c0-1.06-.2-2.023-.6-2.886a4.883 4.883 0 00-1.78-2.069c-.786-.515-1.746-.772-2.88-.772-1.118 0-2.126.238-3.026.716a5.236 5.236 0 00-2.12 2.056c-.513.894-.77 1.94-.77 3.137 0 1.212.28 2.254.839 3.125.56.87 1.334 1.526 2.323 1.966.99.439 2.128.659 3.412.659zm.658-6.773h-2.857a1.47 1.47 0 01.42-1.09c.294-.32.63-.478 1.008-.478.469 0 .824.166 1.066.5.242.333.363.69.363 1.068z"
      />
      <g transform="translate(.03 9.704)">
        <use fill="#FAFAFA" xlinkHref="#nav_logo_a" />
        <use fill="#000" filter="url(#nav_logo_b)" xlinkHref="#nav_logo_a" />
        <ellipse cx="19.821" cy="10.282" fill="#EEE" rx="12.636" ry="5.327" />
      </g>
      <g filter="url(#nav_logo_c)" transform="rotate(-7 26.988 -64.866)">
        <g transform="matrix(-1 0 0 1 22.338 0)">
          <use fill="url(#nav_logo_d)" xlinkHref="#nav_logo_e" />
          <use fill="#000" filter="url(#nav_logo_f)" xlinkHref="#nav_logo_e" />
        </g>
        <use fill="url(#nav_logo_g)" xlinkHref="#nav_logo_h" />
        <use fill="#000" filter="url(#nav_logo_i)" xlinkHref="#nav_logo_h" />
        <g transform="matrix(-1 0 0 1 21.135 0)">
          <use fill="url(#nav_logo_j)" xlinkHref="#nav_logo_k" />
          <use fill="#000" filter="url(#nav_logo_l)" xlinkHref="#nav_logo_k" />
        </g>
        <g transform="matrix(-1 0 0 1 21.335 0)">
          <use fill="url(#nav_logo_m)" xlinkHref="#nav_logo_n" />
          <use fill="#000" filter="url(#nav_logo_o)" xlinkHref="#nav_logo_n" />
        </g>
        <g transform="rotate(-4 14.098 -105.672)">
          <use fill="#000" filter="url(#nav_logo_p)" xlinkHref="#nav_logo_q" />
          <use fill="url(#nav_logo_r)" xlinkHref="#nav_logo_q" />
          <use fill="#000" filter="url(#nav_logo_s)" xlinkHref="#nav_logo_q" />
          <path
            fill="#F9F9EF"
            d="M5.113 0c.105.072.171.144.271.216.61.488.726 1.314.38 1.911-.525.912-4.213.898-5.083 2.247L.7 4.33c.457-1.037 1.404-1.736 2.84-2.094l.044-.011C5.507 1.757 6.04 1.015 5.113 0z"
          />
          <path
            fill="url(#nav_logo_t)"
            d="M5.113 0l.091.104c.798.962.237 1.67-1.62 2.12l-.043.012c-1.333.333-2.244.958-2.734 1.876C1.25 3.16 2.1 2.387 3.358 1.796 4.74 1.146 5.325.548 5.113 0z"
          />
        </g>
      </g>
    </g>
  </svg>
)
